import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import AccordionTransition from 'UIComponents/transitions/AccordionTransition';
import { useState } from 'react';
import { getProductLevelFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import GenericBundleFeatureTable from '../feature-table/suite-feature-table/GenericBundleFeatureTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileBundleFeatureTable = ({
  apiNames,
  productLevel,
  screen
}) => {
  const [showFeatureTable, setShowFeatureTable] = useState(false);
  const toggleShowFeatureTable = evt => {
    evt.preventDefault();
    setShowFeatureTable(prev => !prev);
  };
  const filteredHighlightedProducts = apiNames.filter(apiName => {
    return getProductLevelFromApiNameString(apiName) === productLevel;
  });
  return /*#__PURE__*/_jsxs("div", {
    className: "m-top-5 text-center",
    children: [/*#__PURE__*/_jsx(UIButton, {
      use: "transparent",
      onClick: toggleShowFeatureTable,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: showFeatureTable ? 'suiteFeatureTable.mobile.hideAll' : 'suiteFeatureTable.mobile.seeAll'
      })
    }), /*#__PURE__*/_jsx(AccordionTransition, {
      style: {
        maxWidth: '100%'
      },
      duration: 500,
      renderContent: () => /*#__PURE__*/_jsx(GenericBundleFeatureTable, {
        apiNames: filteredHighlightedProducts
        // Resets expanded state of table content
        ,

        screen: screen
      }, productLevel),
      open: showFeatureTable
    })]
  });
};
export default MobileBundleFeatureTable;